<template lang="pug">
  .agency-news-type
    v-autocomplete(
      v-model="lazyValue"
      dense
      clearable
      outlined
      attach
      multiple
      item-value="value"
      item-text="name"
      :disabled="isDisabled"
      :items="lazyTranslatedItems"
      :label="$t($lang.newsType.NEWS_TYPE)"
      :placeholder="$t($lang.app.CHOOSE)"
      :menu-props="{ maxHeight: 150, offsetY: true }"
    )
</template>

<script>
import { useContext } from '@/compat';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import { onMounted, ref } from 'vue';
import { useSelectedSorter } from '@/helpers/misc';
import { filterSelectedValues } from '@/helpers/content';
import { AgencyNewsTypes } from '@/components/agency/constants';

export default {
  name: 'AgencyNewsType',
  props: {
    value: {
      type: Array,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { $lang, $i18n } = useContext();
    const { lazyValue } = useModelAutoBinding(emit, props);
    const translatedItems = ref([]);

    const getNewsType = () => {
      translatedItems.value = AgencyNewsTypes.map(item => ({
        value: item.value,
        name: $i18n.t($lang.agencyNewsType[item.langKey]),
      }));
    };

    onMounted(() => getNewsType());
    const [lazyTranslatedItems] = useSelectedSorter(translatedItems, lazyValue, filterSelectedValues, 'value');

    return {
      lazyValue,
      lazyTranslatedItems,
    };
  },
};
</script>
